import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './ArticleGambit.module.scss';

const propTypes = {
  intro: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark', 'outcome', '']),
  color: PropTypes.oneOf(['default', 'yellow', 'red', 'blue', 'green']),
  left: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small']),
};

const defaultProps = {
  intro: '',
  theme: 'light',
  color: 'default',
  left: false,
  size: 'default',
};

const ArticleGambit = ({ intro, theme, color, left, size }) => {
  const [firstWord, ...words] = intro.split(' ');
  return (
    <section
      data-article-gambit
      className={cx(s.gambit, s[`${theme}Theme`], s[size], { [s.left]: left })}
    >
      <span aria-labelledby="word--first">
        <span aria-hidden="true">
          <span className={['drop-cap', s.dropcap, s[color]].join(' ')}>
            {firstWord.substring(0, 1)}
          </span>
          {firstWord.substring(1)}
        </span>
        <span id="word--first" className={s.hidden}>
          {firstWord}
        </span>
      </span>
      {` ${words.join(' ')}`}
    </section>
  );
};

ArticleGambit.propTypes = propTypes;
ArticleGambit.defaultProps = defaultProps;
export default ArticleGambit;
